export default {
  // 系统管理
  'menu.system': 'System',
  'menu.system.user': 'Users',
  'menu.system.role': 'Roles',
  'menu.system.menu': 'Menus',
  'menu.system.dept': 'Departments',

  // 监控管理
  'menu.monitor': 'Monitor',
  'menu.monitor.login-log': 'Login Log',
  'menu.monitor.oper-log': 'Operation Log',

  // 登录
  'menu.login': 'Login',
  'menu.blindbox.theme': 'Theme',
};
